module.exports = __webpack_public_path__ + "img/remark_10.01f3260c.svg";